"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonicFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rawAmount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint128",
                name: "votes",
                type: "uint128",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rawAmount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rawAmount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class TonicFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(account, overrides) {
        return super.deploy(account, overrides || {});
    }
    getDeployTransaction(account, overrides) {
        return super.getDeployTransaction(account, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TonicFactory = TonicFactory;
TonicFactory.bytecode = _bytecode;
TonicFactory.abi = _abi;
//# sourceMappingURL=TonicFactory.js.map